<template>
  <v-card class="elevation-5" style="border-radius: 8px;">
    <v-card-title class="pb-4 pt-6">
      <v-row justify="space-between" no-gutters>
        <div>
          <h3>{{ formTitle }}</h3>
          <h4 v-if="this.userRole === roles.ADMIN || this.userRole === roles.ADMIN_SIGN">{{ organisationTitle }}</h4>
        </div>
        <v-btn icon large @click="closeHandler" style="transform: translateY(-4px)">
          <v-icon large color="black">close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-card-text class="pb-7">
      <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSubmit">
        <v-row no-gutters class="pb-6" v-if="this.userRole === roles.SUPER_ADMIN">
          <span
            :class="type === user.INDIVIDUAL ? 'active block' : 'not-active block'"
            @click.prevent="onToggleIndividual"
          >
            Физические лица
          </span>
          <span :class="type === user.ENTITY ? 'active block' : 'not-active block'" @click.prevent="onToggleEntity">
            Юридические лица
          </span>
        </v-row>
        <v-row justify="center" no-gutters v-if="type === user.ENTITY && this.userRole === roles.SUPER_ADMIN">
          <v-col cols="3">
            <v-text-field
              label="ИНН организации"
              :rules="organisationInnRules"
              outlined
              v-model="innOrganisation"
              v-mask="mask"
              counter="14"
              autocomplete="off"
              clearable
              validate-on-blur
              id="innOrganisation"
              ref="innOrganisation"
              class="mr-2"
            />
          </v-col>
          <v-col cols="9">
            <v-text-field
              label="Наименование организации"
              outlined
              v-model="displayOrganisationName"
              :append-icon="isEditOrganisationName ? 'edit' : ''"
              :readonly="!isEditOrganisationName"
              :loading="loadingOrganisationName"
              id="showOrganisationName"
              ref="showOrganisationName"
              autocomplete="off"
              class="ml-2"
            />
          </v-col>
        </v-row>
        <v-row justify="center" no-gutters>
          <v-col cols="3">
            <v-text-field
              :label="
                userRole === roles.REGISTRAR || (userRole === roles.SUPER_ADMIN && type === user.INDIVIDUAL)
                  ? 'Персональный номер'
                  : 'ПИН сотрудника'
              "
              :rules="personalInnRules"
              outlined
              v-model="innPersonal"
              v-mask="mask"
              counter="14"
              autocomplete="off"
              clearable
              validate-on-blur
              id="innPersonal"
              ref="innPersonal"
              class="mr-2"
            />
          </v-col>
          <v-col cols="9">
            <v-text-field
              :label="
                userRole === roles.REGISTRAR || (userRole === roles.SUPER_ADMIN && type === user.INDIVIDUAL)
                  ? 'ФИО'
                  : 'ФИО сотрудника'
              "
              outlined
              v-model="displayPersonalName"
              :append-icon="isEditPersonalName ? 'edit' : ''"
              :readonly="!isEditPersonalName"
              :loading="loadingPersonalName"
              id="showPersonalName"
              ref="showPersonalName"
              autocomplete="off"
              class="ml-2"
            />
          </v-col>
        </v-row>
        <v-row no-gutters v-if="type === user.ENTITY && this.userRole === roles.SUPER_ADMIN">
          <v-checkbox label="Назначить администратором" v-model="checkedAdmin" color="primary" class="mr-6" />
          <v-checkbox label="Только для проверки подписей" v-model="checkedSign" color="primary" />
        </v-row>
        <v-divider class="pb-3" />
        <v-row>
          <v-col cols="5">
            <v-row justify="start" align="center" no-gutters>
              <v-col cols="1" class="mr-3">
                <v-radio-group v-model="radiosValue" class="mr-3 mt-7">
                  <v-radio value="radio1" color="#007bff" />
                </v-radio-group>
              </v-col>
              <v-col>
                <span
                  :class="
                    radio2 ? 'modal-card__label modal-card__label-grey' : 'modal-card__label modal-card__label-blue'
                  "
                >
                  Телефон для ПИН-кода
                </span>
                <v-text-field
                  placeholder="777010203"
                  :rules="radio1 ? telNumberRules : []"
                  :disabled="radio2"
                  outlined
                  dense
                  v-model="telNumber"
                  v-mask="telMask"
                  autocomplete="off"
                  clearable
                  validate-on-blur
                />
              </v-col>
            </v-row>
            <v-row justify="start" align="center" no-gutters>
              <v-col cols="1" class="mr-3">
                <v-radio-group v-model="radiosValue" class="mt-7 mr-3">
                  <v-radio value="radio2" color="#007bff" />
                </v-radio-group>
              </v-col>
              <v-col>
                <span
                  :class="
                    radio1 ? 'modal-card__label modal-card__label-grey' : 'modal-card__label modal-card__label-blue'
                  "
                >
                  ПИН-код
                </span>
                <v-text-field
                  placeholder="1234"
                  :rules="radio2 ? pinRules : []"
                  :disabled="radio1"
                  outlined
                  dense
                  v-model="pinCode"
                  v-mask="pinMask"
                  autocomplete="off"
                  clearable
                  validate-on-blur
                />
              </v-col>
            </v-row>
          </v-col>
          <v-spacer />
          <v-col cols="6">
            <span class="d-block mb-6 label pl-1">Загрузить документы</span>
            <v-file-input
              v-if="type === user.INDIVIDUAL"
              dense
              class="mt-0 pt-0"
              clearable
              show-size
              v-model="userPhoto"
              accept="image/jpeg, image/jpg"
              placeholder="Добавить фотографию лица"
            />
            <v-file-input
              dense
              class="mt-0 pt-0"
              clearable
              show-size
              v-model="passportFront"
              accept="image/jpeg, image/jpg"
              placeholder="Добавить лицевую сторону паспорта"
            />
            <v-file-input
              dense
              class="mt-0 pt-0"
              clearable
              show-size
              v-model="passportBack"
              accept="image/jpeg, image/jpg"
              placeholder="Добавить оборотную сторону паспорта"
            />
          </v-col>
          <v-spacer />
        </v-row>
        <v-row justify="center" no-gutters>
          <v-btn color="primary" rounded large class="text-capitalize" type="submit" :loading="loading">
            Зарегистрировать
          </v-btn>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import { mask } from 'vue-the-mask'
import role from '../../services/userRoles'
export default {
  name: 'registrarForm',
  directives: { mask },
  props: {
    userRole: {
      type: String,
      default: '',
      required: true
    }
  },
  updated() {
    if (this.radiosValue === '') {
      this.radiosValue = 'radio1'
    }
  },
  mounted() {
    switch (this.userRole) {
      case this.roles.SUPER_ADMIN:
        this.type = this.user.ENTITY
        this.formTitle = 'Регистрация'
        break
      case this.roles.ADMIN:
      case this.roles.ADMIN_SIGN:
        this.formTitle = 'Добавление регистратора'
        this.type = this.user.ENTITY
        this.regData = role().getRegistrationData(this.type)
        this.organisationTitle = this.userOrganisationName
        break
      case this.roles.REGISTRAR:
      case this.roles.REGISTRAR_SIGN:
        this.type = this.user.INDIVIDUAL
        this.formTitle = 'Регистрация физического лица'
        break
    }
  },
  data: () => ({
    valid: true,
    type: 'entity',
    user: { ENTITY: 'entity', INDIVIDUAL: 'individual' },
    roles: {
      REGISTRAR: 'registrar',
      ADMIN: 'admin',
      SUPER_ADMIN: 'super_admin',
      ADMIN_SIGN: 'admin_sign',
      REGISTRAR_SIGN: 'registrar_sign'
    },
    mask: '##############',
    telMask: '996#########',
    pinMask: '####',
    innOrganisation: '',
    innPersonal: '',
    telNumber: '',
    pinCode: '',
    organisationName: '',
    personalName: '',
    checkedAdmin: false,
    checkedSign: false,
    organisationInnRules: [
      v => !!v || 'Необходимо ввести ИНН организации',
      v => (v && v.length > 13) || 'ИНН организации должен быть равен 14 цифрам'
    ],
    personalInnRules: [
      v => !!v || 'Необходимо ввести ПИН сотрудника',
      v => (v && v.length > 13) || 'ПИН сотрудника должен быть равен 14 цифрам'
    ],
    personaNameRules: [v => !!v || 'Необходимо имя сотрудника'],
    telNumberRules: [
      v => !!v || 'Необходимо ввести номер телефона',
      v => (v && v.length > 11) || 'Номер телефона должен быть равен 12 цифрам'
    ],
    pinRules: [v => (v && v.length > 3) || 'Пин код должен быть равен 4 цифрам'],
    userPhoto: [],
    passportFront: [],
    passportBack: [],
    formTitle: '',
    organisationTitle: '',
    loading: false,
    radio1: true,
    radio2: false,
    radiosValue: '',
    regData: {}
  }),
  watch: {
    innOrganisation(val) {
      if (val && val.length === 14) {
        this.$store.dispatch('GET_INFO_BY_INN', { inn: val, trigger: 'organisation' })
      } else {
        this.$store.commit('CLEAR_NAME', 'organisation')
      }
    },
    innPersonal(val) {
      if (val && val.length === 14) {
        this.$store.dispatch('GET_INFO_BY_INN', { inn: val, trigger: 'personal' })
      } else {
        this.$store.commit('CLEAR_NAME', 'personal')
      }
    },
    radiosValue(val) {
      if (val === 'radio1') {
        this.radio1 = true
        this.radio2 = false
        this.pinCode = ''
      } else {
        this.radio1 = false
        this.radio2 = true
        this.telNumber = ''
      }
    },
    type: {
      immediate: true,
      handler(value) {
        this.regData = role().getRegistrationData(value)
      }
    },
    checkedAdmin: {
      immediate: true,
      handler(value) {
        if (value === undefined) {
          return
        }
        this.regData.isAdmin = value
        value === true ? (this.regData.key = 'RegisterUser') : (this.regData.key = 'RegisterRegistrar')
      }
    },
    checkedSign: {
      immediate: true,
      handler(value) {
        if (value === undefined) {
          return
        }
        this.regData.isSign = value
      }
    }
  },
  computed: {
    displayPersonalName: {
      get() {
        return this.$store.state.registration.response.personalName.name
      },
      set(val) {
        this.personalName = val
      }
    },
    displayOrganisationName: {
      get() {
        return this.$store.state.registration.response.organisationName.name
      },
      set(val) {
        this.organisationName = val
      }
    },
    isEditPersonalName() {
      return this.$store.state.registration.flags.isEditPersonalName
    },
    isEditOrganisationName() {
      return this.$store.state.registration.flags.isEditOrganisationName
    },
    loadingOrganisationName() {
      return this.$store.state.registration.loading.getOrganisationName
    },
    loadingPersonalName() {
      return this.$store.state.registration.loading.getPersonalName
    },
    userOrganisationName() {
      return this.$store.state.user.response.organizationName
    },
    userOrganisationInn() {
      return this.$store.state.user.response.organizationInn
    }
  },
  methods: {
    resetForm() {
      this.valid = true
      this.$refs.form.reset()
      this.$refs.form.resetValidation()
      this.radiosValue = 'radio1'
    },
    setupEditableFieldsToFalse() {
      for (let i = 0; i < arguments.length; i++) {
        this.$store.commit('SETUP_EDITABLE_FIELD', { payload: false, type: arguments[i] })
      }
    },
    async closeHandler() {
      this.$emit('close-form', false)
      await this.resetForm()
      this.setupEditableFieldsToFalse('organisation', 'personal')
      const data = role().getRegistrationData(this.type)
      this.regData = { ...data }
    },
    onToggleIndividual() {
      this.type = this.user.INDIVIDUAL
      this.resetForm()
    },
    onToggleEntity() {
      this.type = this.user.ENTITY
      this.resetForm()
    },
    async createFormData() {
      const isOrgName = this.$store.state.registration.response.organisationName.name
      const formData = new FormData()
      formData.append('isAdmin', this.regData.isAdmin)
      formData.append('isSign', this.regData.isSign)

      if (this.type === this.user.ENTITY && this.innOrganisation) {
        await formData.append('innOrganisation', this.innOrganisation)
      }
      if (this.type === this.user.ENTITY && isOrgName) {
        await formData.append(
          'organisationName',
          this.organisationName ? this.organisationName : this.$store.state.registration.response.organisationName.name
        )
      }
      await formData.append('inn', this.innPersonal)
      await formData.append(
        'fullname',
        this.personalName ? this.personalName : this.$store.state.registration.response.personalName.name
      )

      if (this.telNumber) await formData.append('phone', this.telNumber)
      if (this.pinCode) await formData.append('pinCode', this.pinCode)
      await formData.append('isPinCodeOneShot', 'false')

      try {
        if (this.type === this.user.INDIVIDUAL) await formData.append('userPhoto', this.userPhoto, 'userPhoto.jpg')
        await formData.append('passportFront', this.passportFront, 'passportFront.jpg')
        await formData.append('passportBack', this.passportBack, 'passportBack.jpg')
        return formData
      } catch (e) {
        this.loading = false
        await this.$store.dispatch('NOTIFICATION', {
          open: true,
          color: 'error',
          text: 'Не все документы были загружены'
        })
      }
    },
    async onSubmit() {
      if (this.$refs.form.validate()) {
        const formData = await this.createFormData()
        this.loading = true
        await this.$store.dispatch('REGISTRATION_CUSTOMERS', {
          formData,
          endpointType: this.regData.key,
          dispatchType: this.regData.type[this.$router.history.current.name]
        })
        this.loading = false
        this.closeHandler()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h3 {
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  display: block;
  margin-bottom: 16px;
}
h4 {
  font-weight: 600;
  font-size: 24px;
  display: block;
  margin-bottom: 16px;
}
.label {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  color: #007aff;
}
.active {
  background: #e8f0fe;
  color: #007aff;
}
.not-active {
  background: transparent;
  color: #757575;
}
.block {
  border-radius: 4px;
  padding: 8px 20px;
  font-weight: 600;
  font-size: 14px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
}
.modal-card {
  &__label {
    display: block;
    margin-bottom: 8px;
    font-weight: 600;
    font-size: 20px;
    line-height: 27px;
  }
  &__label-blue {
    color: #007aff;
  }
  &__label-grey {
    color: grey;
  }
}
</style>
